import React, { useState } from "react";
import Dropzone from "./components/Dropzone";
import { HashRouter as Router, Routes, Route } from "react-router-dom";
import SendFiles from "./components/SendFiles";

function App() {
  const [files, setFiles] = useState([]);
  const [urlDownload, setUrlDownload] = useState(null);

  return (
    <Router>
      <Routes>
        <Route
          path="/"
          element={
            <div>
              <div style={{ padding: "15px" }}>
                <div style={{ textAlign: "center", padding: "20px 0 40px 0" }}>
                  <h1 className="bp4-heading" style={{ color: "#FFFFFF" }}>
                    {"Send super big file."}
                  </h1>
                  <h3 className="bp4-heading" style={{ color: "#FFFFFF" }}>
                    {"Simple. Fast. Beautiful. "}
                  </h3>
                  <h6 className="bp4-heading" style={{ color: "#FFFFFF" }}>
                    {"( 5 GB available. 3 days to download them )"}
                  </h6>
                </div>

                <Dropzone
                  files={files}
                  setFiles={setFiles}
                  setUrlDownload={setUrlDownload}
                />
              </div>
            </div>
          }
        ></Route>
        <Route
          path="/send"
          element={
            <div>
              <div style={{ padding: "15px" }}>
                <SendFiles urlDownload={urlDownload} />
              </div>
            </div>
          }
        ></Route>
      </Routes>
    </Router>
  );
}

export default App;
